import { Alert, AlertDescription, AlertIcon, AlertTitle, Box, CloseButton } from '@chakra-ui/react';
import { useMessage } from './messageContext';

export function MessageAlert() {
  const { message, clearMessage } = useMessage();

  if (!message) return null;

  return (
    <Box maxW="xl" mx="auto" mt={4}>
      <Alert
        status={message.status}
        variant="solid"
        flexDirection="column"
        alignItems="start"
        justifyContent="start"
        textAlign="left"
        borderRadius="md"
        py={4}
        px={6}
      >
        <CloseButton position="absolute" right={2} top={2} onClick={clearMessage} />
        <AlertIcon boxSize="20px" mr={0} />
        {message.title && (
          <AlertTitle mt={2} mb={1} fontSize="lg">
            {message.title}
          </AlertTitle>
        )}
        <AlertDescription>{message.description}</AlertDescription>
      </Alert>
    </Box>
  );
}
